import { Link } from "react-router-dom"
import { Shield } from "lucide-react"

export const PublicFooter = () => {
  const openCookiePrefs = () => {
    localStorage.removeItem("itacondo_cookie_consent_v1")
    window.location.reload()
  }
  return (
    <footer className="bg-slate-900 text-slate-300 py-10 border-t border-slate-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-center gap-2 text-sm">
            <Shield className="h-4 w-4 text-blue-400" />
            <span>Em conformidade com a LGPD — Lei 13.709/2018</span>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
            <Link to="/politica-privacidade" className="hover:text-white">Política de Privacidade</Link>
            <Link to="/termos-de-uso" className="hover:text-white">Termos de Uso</Link>
            <Link to="/encarregado-de-dados" className="hover:text-white">Encarregado (DPO)</Link>
            <button onClick={openCookiePrefs} className="hover:text-white">Gerenciar cookies</button>
          </nav>
        </div>
        <p className="text-xs text-slate-500 mt-6 text-center md:text-left">
          © {new Date().getFullYear()} itaCondo. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  )
}

export default PublicFooter
